import { render, staticRenderFns } from "./ConfigBackgroundPlayer.vue?vue&type=template&id=22760b96"
import script from "./ConfigBackgroundPlayer.vue?vue&type=script&lang=js"
export * from "./ConfigBackgroundPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports